/**
 * Field — vertical Label + control + helper-text grouping.
 *
 * Matches the prototype's `.field` block: a column-flex container with a
 * 6px gap. Pass `error` to swap helper text to the bad-color message slot
 * (used by `Form` field bindings).
 */
import * as React from "react";
import { cn } from "../lib/cn.js";

export interface FieldProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Optional helper or hint shown below the control. Hidden when `error` is set. */
  helper?: React.ReactNode;
  /** Field-level error message (e.g. from `formState.errors[name]?.message`). */
  error?: React.ReactNode;
}

export const Field = React.forwardRef<HTMLDivElement, FieldProps>(function Field(
  { className, helper, error, children, ...props },
  ref,
) {
  return (
    <div ref={ref} className={cn("flex flex-col gap-1.5", className)} {...props}>
      {children}
      {error ? (
        <p className="text-xs leading-[16px] text-bad" role="alert">
          {error}
        </p>
      ) : helper ? (
        <p className="text-xs leading-[16px] text-muted">{helper}</p>
      ) : null}
    </div>
  );
});
